var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartHealth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 61,
    fill: "#F5F7F9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_9742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.0027 86.1641C61.0027 86.1641 36.0027 72.1641 36.0027 55.1641C36.0032 52.1594 37.0443 49.2477 38.949 46.9239C40.8538 44.6001 43.5045 43.0077 46.4507 42.4174C49.3968 41.8272 52.4564 42.2755 55.1093 43.6862C57.7622 45.0968 59.8447 47.3828 61.0027 50.1553L61.0027 50.1554C62.1606 47.3828 64.2431 45.0968 66.896 43.6862C69.549 42.2755 72.6086 41.8272 75.5547 42.4174C78.5008 43.0077 81.1516 44.6001 83.0563 46.9239C84.9611 49.2477 86.0022 52.1594 86.0027 55.1641C86.0027 72.1641 61.0027 86.1641 61.0027 86.1641Z",
    fill: "#FC4551"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9999 70.1615C84.9999 76.4207 79.9258 81.4948 73.6666 81.4948C67.4074 81.4948 62.3333 76.4207 62.3333 70.1615C62.3333 63.9023 67.4074 58.8281 73.6666 58.8281C79.9258 58.8281 84.9999 63.9023 84.9999 70.1615ZM82.3333 70.1615C82.3333 74.948 78.4531 78.8281 73.6666 78.8281C68.8801 78.8281 64.9999 74.948 64.9999 70.1615C64.9999 65.3749 68.8801 61.4948 73.6666 61.4948C78.4531 61.4948 82.3333 65.3749 82.3333 70.1615Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6667 66.8307L73 64.1641H78.3333L79.6667 66.8307L81 69.4974L79.6667 70.8307L78.3333 69.4974L75.6667 66.8307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9999 70.8333L66.3333 69.5L66.3333 74.8333L68.9999 76.1667L71.6666 77.5L74.3333 76.1667L71.6666 74.8333L68.9999 70.8333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.3636,
    cy: 70.7074,
    r: 12.3636,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8181 69.2514L69.7272 74.3423L79.1818 67.7969",
    stroke: "#3BC98D",
    strokeWidth: 2.18182,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_9742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(29 32.1641)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartHealth);
export default __webpack_public_path__ + "static/media/heart-health.b483885e2f1247bf4b7720cd8d2506b9.svg";
export { ForwardRef as ReactComponent };